module.exports = "label{\r\n    word-wrap: break-word;\r\n    display: block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing/unify-marketing-note/unify-marketing-note.component.css
// module id = ./src/app/prospect/unify-marketing/unify-marketing-note/unify-marketing-note.component.css
// module chunks = main